import moment from "moment";

export function createChangeHandle(context, stateField = null) {
    let handler;
    if (stateField) {
        handler =  function (event) {
            this.setState({
                [stateField]: {
                    ...this.state[stateField],
                    [event.target.name]: event.target.value,
                }
            });
        }
    } else {
        handler = function(event) {
            this.setState({
                [event.target.name]: event.target.value,
            });
        }
    }

    return handler.bind(context);
}

export function loadToState(componentContext, requestPromise, prop, dataMapper = null) {
    requestPromise.then(response => {
        if (response.success) {
            componentContext.setState({
                [prop]: dataMapper ? dataMapper(response.data) : response.data,
            })
        }
    })
}

export function parseTimeStringToDate(timeStr) {
    if (moment.isMoment(timeStr)) {
        return timeStr;
    }

    if (typeof timeStr !== 'string') return null;

    const [hours, minutes] = timeStr.split(':');
    if (!hours || !minutes) return null;

    const date = new Date();
    date.setHours(Number(hours));
    date.setMinutes(Number(minutes));
    date.setSeconds(0);
    date.setMilliseconds(0);
    return date;
}

export function convertToBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.readAsDataURL(file);

        reader.onload = () => {
            if (typeof reader.result === 'string') {
                resolve(reader.result);
            } else {
                reject('Ошибка при чтении файла');
            }
        };

        reader.onerror = (error) => reject(error);
    });
}

export function returnChangedFieldsEditSeries(dataToSend, originalData) {
    const changedFields = {};

    for (const key in dataToSend) {
        const originalKey = key === "executorParam" ? "seriesExecutorParam" : key;

        if (dataToSend[key] !== originalData[originalKey]) {
            changedFields[key] = dataToSend[key];
        }
    }

    return changedFields
}

export function returnChangedFieldsEditStep(dataToSend, originalData) {
    const changedFields = {};

    for (const key in dataToSend) {
        let originalKey = key;
        if (key === "executorParam") originalKey = "seriesStepExecutorParam";
        if (key === "transportIds") originalKey = "transports";
        if (key === "seriesId") continue;

        const newValue = dataToSend[key];
        const oldValue = originalData[originalKey];

        if (Array.isArray(newValue)) {
            const newIds = newValue.map(v => (typeof v === "object" && v !== null ? v.id ?? v.name ?? v : v));
            const oldIds = Array.isArray(oldValue)
                ? oldValue.map(v => (typeof v === "object" && v !== null ? v.id ?? v.name ?? v : v))
                : [];

            const isDifferentLength = newIds.length !== oldIds.length;
            const hasDifferentValues =
                newIds.some(v => !oldIds.includes(v)) || oldIds.some(v => !newIds.includes(v));

            if (isDifferentLength || hasDifferentValues) {
                changedFields[key] = newValue;
            }

            continue;
        }

        if (newValue !== oldValue) {
            changedFields[key] = newValue;
        }
    }

    return changedFields;
}